import React from "react";
import { AHIcon, Circle, TouchableBox } from "arkh";

export function WidgetSettingsButton({
  onPress,
  padding,
}: {
  onPress(): void;
  padding: number;
}) {
  return (
    <TouchableBox
      onPress={onPress}
      style={{ position: "absolute", top: 0, right: 0, padding }}
      hitSlop={{ top: 5, bottom: 30, left: 40, right: 5 }}
    >
      <Circle borderColor="washedText" color="washedText" size="medium">
        <AHIcon type="more" color="surface" size="medium" />
      </Circle>
    </TouchableBox>
  );
}
